<template>
  <div
    v-if="basePrices"
    :class="[
      'base-price-fi',
      small ? 'base-price-fi--small' : '',
      theme ? `base-price-fi--theme-${theme}` : '',
    ]"
  >
    <div
      v-for="(basePrice, idx) in basePrices"
      :key="idx"
    >
      <span
        v-if="showLabel"
        class="base-price-fi__label"
      >
        {{ dict.get('online-Shop.Product.Base-Price') }}:
      </span>

      <template v-if="basePrice?.valueFormatted">
        {{ basePrice.valueFormatted }}
      </template>

      <template v-if="bestPrice?.priceRows && basePrice">
        / {{ basePrice.qty }} {{ getSellingUnit(basePrice.unit || '')
        }}{{ idx !== basePrices.length - 1 ? ', ' : '' }}
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useDict } from '@/composables/fischerPlugin';
import { useSellingUnits } from '@/composables/sellingUnit';

defineOptions({
  name: 'BasePriceFi',
});

interface BasePrice {
  unit?: string | null;
  qty?: any | null;
  valueFormatted?: string | null;
}

const props = withDefaults(
  defineProps<{
    bestPrice?: {
      priceRows?: any;
      price?: {
        basePrices?: Array<BasePrice | null> | null;
      } | null;
    } | null;
    small?: boolean;
    theme?: string | null;
    showLabel?: boolean;
  }>(),
  {
    bestPrice: () => ({}),
    theme: null,
  },
);

const { getSellingUnit } = useSellingUnits();

const basePrices = computed<Array<BasePrice | null> | null>(
  () => props.bestPrice?.price?.basePrices || null,
);
const dict = useDict();
</script>

<style scoped src="./base-price-fi" />
